<template>
  <div class="avatarContainer" @click="$emit('set-active')">
    <b-list-group-item class="d-flex align-items-start list-groupelt">
      <b-avatar variant="info" :src="`${user.avatar}`" :class="{'mr-3':active}"
                style="width: 50px; height: 50px"></b-avatar>
      <transition name="slide-fade">
        <span v-if="active" class="mr-3"><div>{{ user.full_name }}</div><div
          class="coloredText">{{ user.parent_type }}</div></span>
      </transition>
    </b-list-group-item>
  </div>
</template>

<script>
export default {
  props: {
    user: {required: true},
    active: {default: false}
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.avatarContainer {
  /* border: red 1px solid; */
  width: fit-content;
  border-radius: 50px;
  cursor: pointer;
}

.list-groupelt {
  padding: 2px 4px !important;
  /* border: green 1px solid; */
}

.coloredText {
  font-size: 11px;
  color: teal;
  margin-top: -2px;
}

/* animation */
.slide-fade-enter-active {
  transition: all .3s ease-in;
}

.slide-fade-leave-active {
  transition: all .3s ease-out;;
}

.slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(-4px);
  opacity: 0;
}
</style>
